var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"copyright ce-frame mx-auto",class:[_vm.isSearchPage ? 'ce-frame--widescreen' : '']},[_c('div',{staticClass:"copyright__content"},[_c('p',{staticClass:"tw-text-15 mb-0"},[_vm._v("\n      "+_vm._s(_vm.$t('labels.generic.copyright', {
          ISBN13: _vm.isbn,
          PUBLISHER: _vm.publisher,
          YEAR: _vm.copyrightYear
        }))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }